/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { IntlProvider, addLocaleData } from 'react-intl'
import flatten from 'flat'
import React, { Component } from 'react'
import qs from 'qs'
import helpers from 'helpers'

// import LocaleStore from '../store'
import * as intlActions from '../actions/components/intl'
import * as _ from 'lodash'
/**
 * Import Locales
 */
import zhHK from './locales/zh_HK'
import zhTW from './locales/zh_TW'
import enUS from './locales/en_US'
import en from 'react-intl/locale-data/en'
import zh from 'react-intl/locale-data/zh'

/**
 * Config
 */
addLocaleData([
  ...zh,
  ...en,
])

class HotSwappingIntlProvider extends Component {
  constructor (props) {
    super(props)
    this.state = {
      locale: '',
      messages: '',
      fallbackLocale: '',
    }
  }

  componentDidUpdate = (prevProps) => {
    const {
      storeLocale,
      switchLocale,
    } = this.props
    if (storeLocale == null || storeLocale === undefined || storeLocale === '') {
      switchLocale(this.props.locale)
    } else {
      if (prevProps.locale !== this.props.locale) {
        switchLocale(this.props.locale)
      }
    }
  }

  render () {
    const {
      locale,
      messages,
    } = this.props

    var state = { locale: locale, messages: messages }
    return (
      <IntlProvider {...state}>
        {this.props.children}
      </IntlProvider>
    )
  }
}

const mapStateToProps = (state) => {
  const storeLocale = state.locale
  let locale = state.locale
  let messages = ''
  let fallbackLocale = state.fallbackLocale
  const params = qs.parse(window.location.search.slice(1))
  const paramsLanguage = params.l

  if (paramsLanguage && state.merchant) {
    const matchedLocale = _.find(state.merchant.clientLocales, o => paramsLanguage.includes(o))

    if (matchedLocale) {
      locale = matchedLocale
    }
  } else if (state.merchant != null && state.merchant !== undefined) {
    const browserLang = window.navigator.userLanguage || window.navigator.language
    const defaultClientLanguage = state.merchant.setting.defaultClientLanguage
    // if merchant info has been fetched

    let isMatch = false
    if (!storeLocale && defaultClientLanguage) {
      const matchedLocale = _.find(state.merchant.clientLocales, o => {
        return defaultClientLanguage === o
      })
      if (matchedLocale) {
        locale = matchedLocale
        isMatch = true
      }
    } else if (storeLocale == null || storeLocale === undefined) {
      // auto choose user's browser language if storelocale is not set yet
      const matchedLocale = _.find(state.merchant.clientLocales, o => browserLang.includes(o))
      if (matchedLocale) {
        locale = matchedLocale
        isMatch = true
      }
    } else {
      // if storelocale is set, check if storelocale is present in client locales
      const matchedLocale = _.find(state.merchant.clientLocales, o => storeLocale.includes(o))
      if (matchedLocale) {
        locale = matchedLocale
        isMatch = true
      }
    }
    if (!isMatch) {
      locale = state.merchant.clientLocales[0]
    }
  } else if (storeLocale != null && storeLocale !== undefined && storeLocale !== '') {
    // if merchant info has been not been fetched and store locale has been specified
    locale = storeLocale
  } else {
    fallbackLocale = 'zh'
    locale = fallbackLocale
  }

  switch (locale) {
    case 'en':
      messages = flatten(enUS)
      break
    case 'zh':
      if (helpers.location.getLocation() === 'TW') {
        messages = flatten(zhTW)
      } else {
        messages = flatten(zhHK)
      }
      break
    default:
      if (helpers.location.getLocation() === 'TW') {
        messages = flatten(zhTW)
      } else {
        messages = flatten(zhHK)
      }
      break
  }
  return {
    storeLocale,
    locale,
    messages,
    fallbackLocale,
  }
}

const mapDispatchToProps = (dispatch) => {
  const { switchLocale, setUserLocale } = bindActionCreators(intlActions, dispatch)
  return {
    switchLocale,
    setUserLocale,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HotSwappingIntlProvider)



// WEBPACK FOOTER //
// ./src/intl/hotswappingintl.js